import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { from, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MapsLoaderService {
  private loader = new Loader({
    apiKey: 'AIzaSyAfPD6UjmCHWIoE9A52EJNZjsF9YiyzuC0',
  });

  load(): Observable<google.maps.PlacesLibrary> {
    // Dynamisch nur die Places-Bibliothek als Observable laden
    return from(this.loader.importLibrary('places'));
  }
}
